import { createContext, useContext } from 'react';

export interface ClientUser {
  clientRef: string;
  displayName: string;
  email: string;
  status: string;
  onboardingStatus: string | null;
  pendingSignatures: number;
  pendingQueries: number;
}

export interface ClientAuthContextValue {
  user: ClientUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}

export const ClientAuthContext = createContext<ClientAuthContextValue>({
  user: null,
  isAuthenticated: false,
  isLoading: true,
});

export function useClientAuth(): ClientAuthContextValue {
  return useContext(ClientAuthContext);
}
